
require('./bootstrap');

// import Vue from 'vue';

// import ExampleComponent from './components/ExampleComponent'


// const app = new Vue({
//     el: '#app',
//     components: {
//         ExampleComponent
//     }
// });

initSelect2 = function (objectIdentifier, placeholder, params){

    var minimumInputLength;
    if(_.isUndefined(params.minimumInputLength))
    {
        minimumInputLength = -1;
    }
    else
    {
        minimumInputLength = params.minimumInputLength;
    }

    $(objectIdentifier).select2({
        "placeholder":placeholder,
        "width": _.isUndefined(params.width) ? "resolve" : params.width,
        "minimumInputLength": minimumInputLength,
        "allowClear": _.isUndefined(params.allowClear) ? false : params.allowClear,
        //"allowClear":false,
        //"language": select2Locale,
        "disabled": _.isUndefined(params.disabled) ? false : params.disabled,
        "multiple":params.multiple,
        "dataAdapter": !_.isUndefined(params.dataAdapter) ? params.dataAdapter : null,
        "defaultResults": !_.isUndefined(params.defaultResults) ? params.defaultResults : null,
        "minimumResultsForSearch": _.isUndefined(params.minimumResultsForSearch) ? 0 : params.minimumResultsForSearch,
        "ajax": {
            beforeSend: function(xhr)
            {
                xhr.setRequestHeader('Access-Token', window.access_token);
            },
            url:params.ajax.url,
            data:params.ajax.data,
            processResults:params.ajax.processResults,
            dataType: 'json',
            error:function(jqXHR,data)
            {
                if(jqXHR.status === 498)
                {
                    refreshToken(null, objectIdentifier);
                }
            },
            cache: false,
        },
        escapeMarkup: _.isUndefined(params.escapeMarkup) ? $.fn.select2.defaults.defaults.escapeMarkup : params.escapeMarkup,

    });
    if (_.isUndefined(params.allowClear) || params.allowClear === true){
        $(objectIdentifier).on('select2:unselecting', function(){
            $(this).data('state', 'unselected');
        }).on('select2:open', function(e){
            if ($(this).data('state') === 'unselected') {
                $(this).removeData('state');

                var self = $(this);
                setTimeout(function() {
                    self.select2('close');
                }, 1);
            }
        });
    }
}

fillInUser = function (data, object) {

    object.find("[name='first_name']").val(data.first_name);
    object.find("[name='last_name']").val(data.last_name);
    object.find("[name='email']").val(data.email);
    object.find("[name='username']").val(data.username);
    if (!data.is_active) {
        object.find("[name='is_active']").removeAttr('checked').iCheck('update');
    }
    $("#user_role_id").empty().append('<option selected value="' + data.role.id + '">' + data.role.name + '</option>');
    $("#user_role_id").select2('data', {
        id: data.role.id,
        label: data.role.name
    });

    if(data.role.slug === 'user-role-pub-editor'){
        $('.party-selector').removeAttr('hidden');
    }

    if(data.role.slug === 'user-role-pub-editor' && data.party != null){
        if(data.party.imprints_concat != null){
            $("#party_id").empty().append('<option selected value="' + data.party.PARTY_ID + '">' + data.party.PARTY_NAME + ' [' + data.party.imprints_concat + ']</option>');
            $("#party_id").select2('data', {
                id: data.party.PARTY_ID,
                label: data.party.PARTY_NAME + ' [' + data.party.imprints_concat + ']'
            });
        }else {
            $("#party_id").empty().append('<option selected value="' + data.party.PARTY_ID + '">' + data.party.PARTY_NAME + '</option>');
            $("#party_id").select2('data', {
                id: data.party.PARTY_ID,
                label: data.party.PARTY_NAME
            });
        }
    }
}

fillInProduct = function (data, object, isDuplicate = false) {

    console.log(data);
/*    if (!data.hasOwnProperty('isTemp') || (data.hasOwnProperty('isTemp') && data['isTemp'] === false)) {
        $('#create_date').val(data.ADD_PRODUCT_TS);
        $('#update_date').val(data.LAST_UPDATE);
    }*/
	if (data.hasOwnProperty('isTemp') && data['isTemp'] === true){
		$('#web_show_status_yes').iCheck('check');
	}else {
		if(data.PRODUCT_STATUS === 'ACTIVE'){
			$('#web_show_status_yes').iCheck('check');
		}else{
			$('#web_show_status_no').iCheck('check');
		}
	}
    if (data.hasOwnProperty('isTemp') && data['isTemp'] === true) {
        $('#party_id, #imprint_id, #isbn_id, #isbn_aa, #legal_deposit_number').removeAttr('disabled');
        $('#isbn_aa').val(data['isbn_aa']);
        $('#isbn_dc').val(data['isbn_dc']);
        $("#isbn_id").empty().append('<option selected value="' + data.isbn_id.ISBN_PREFIX_ID + '">' + data.isbn_id.ISBN_PREFIX + '</option>');
        $("#isbn_id").select2('data', {
            id: data.isbn_id.ISBN_PREFIX_ID,
            label: data.isbn_id.ISBN_PREFIX
        });
    }
    if (data.hasOwnProperty('PUBLISHING_STATUS')) {
        $('#publishing_status').val(data.PUBLISHING_STATUS).trigger('change');
        if (data.PUBLISHING_STATUS === 'OUT_OF_PRINT') {
            $('.deletion-date-group :input').removeAttr('disabled');
            $('.deletion-date-group').show();
        }
    }
    if(!isDuplicate) {
        if (data.hasOwnProperty('product_imprint') && data.product_imprint !== null) {
            if (data['product_imprint'].hasOwnProperty('imprint')) {
                $("#imprint_id").empty().append('<option selected value="' + data.product_imprint.imprint.IMPRINT_ID + '">' + data.product_imprint.imprint.NAME + '</option>');
                $("#imprint_id").select2('data', {
                    id: data.product_imprint.imprint.IMPRINT_ID,
                    label: data.product_imprint.imprint.NAME
                });
                $('#imprint_id').removeAttr('disabled');

                if (data['product_imprint']['imprint'].hasOwnProperty('party_imprint')) {
                    if (data['product_imprint']['imprint']['party_imprint'].hasOwnProperty('party')) {
                        var party = data.product_imprint.imprint.party_imprint.party;
                        $("#party_id").empty().append('<option selected value="' + party.PARTY_ID + '">' + party.PARTY_NAME + '</option>');
                        $("#party_id").select2('data', {
                            id: party.PARTY_ID,
                            label: party.PARTY_NAME
                        });
                        if (!(data.hasOwnProperty('isTemp') && data['isTemp'] === true)) {
                            //$('#party_id').attr('disabled', 'disabled');
                        }
                    }
                }
            }
        }
    }else{
        if (data.hasOwnProperty('product_imprint') && data.product_imprint !== null) {
            if (data['product_imprint'].hasOwnProperty('imprint')) {
                if (data['product_imprint']['imprint'].hasOwnProperty('party_imprint')) {
                    if (data['product_imprint']['imprint']['party_imprint'].hasOwnProperty('party')) {
                        var party = data.product_imprint.imprint.party_imprint.party;
                        $("#party_id").empty().append('<option selected value="' + party.PARTY_ID + '">' + party.PARTY_NAME + '</option>');
                        $("#party_id").select2('data', {
                            id: party.PARTY_ID,
                            label: party.PARTY_NAME
                        });
                        $('#imprint_id').removeAttr('disabled');
                    }
                }
            }
        }
    }
    if ((data.hasOwnProperty('CO_PUBLISHER_NAME') && data.CO_PUBLISHER_NAME !== null)
        ||(data.hasOwnProperty('CO_PUB_TYPE') && data.CO_PUB_TYPE !== null)) {
        $('.add_co_publisher_btn i').removeClass('fa-hexagon-plus');
        $('.add_co_publisher_btn i').addClass('fa-hexagon-minus');
        $('.add_co_publisher_btn span').text('Αφαίρεση συνεκδότη');
        $(".co_publisher_group :input").removeAttr('disabled');
        $(".co_publisher_group").show();
        $('#co_publisher_name').val(data['CO_PUBLISHER_NAME']);
        if (data.hasOwnProperty('CO_PUB_TYPE')) {
            $('#co_publisher_type_id').val(data['CO_PUB_TYPE']).trigger('change');
        }
    }
    if (data.hasOwnProperty('identifiers')) {
        $.each(data['identifiers'], function (key, value) {
            if (value.ID_TYPE === 'ISBN_13') {
                $('#isbn_13').val(value.ID_VALUE);
            } else if (value.ID_TYPE === 'GTIN_13') {
                if(!isDuplicate)
                    $('#gtin_id').val(value.ID_VALUE);
            } else if (value.ID_TYPE === 'LEGAL_DEPOSIT_NUMBER') {
                if(!isDuplicate) {
                    $('#legal_deposit_number').val(value.ID_VALUE);
                }
                $('#legal_deposit_number').removeAttr('disabled');
            } else if (value.ID_TYPE === 'CO_PUBLISHER_ISBN_13') {
                $('#co_publisher_isbn').val(value.ID_VALUE);
            }
        });
    }
    if (data.hasOwnProperty('title_detail') && data.title_detail !== null) {
        $.each(data['title_detail'], function (key, value) {
            if (value.TITLE_TYPE === 'DISTINCTIVE_TITLE') {
                if (value.hasOwnProperty('title_element') && value.title_element !== null) {
                    $('#title').val(value.title_element.TITLE_TEXT);
                    $('#subtitle').val(value.title_element.SUBTITLE);
                }
            } else if (value.TITLE_TYPE === 'TITLE_ORIGINAL_LANGUAGE' ) {
                if (value.hasOwnProperty('title_element') && value.title_element !== null) {
					if (data.hasOwnProperty('isTemp') && data['isTemp'] === true){
                    $('#translated').iCheck('check');
                    $(".original_language_group :input").removeAttr('disabled');
                    $(".original_language_group").show();
					}
                    $('#original_title').val(value.title_element.TITLE_TEXT);
                    $('#original_subtitle').val(value.title_element.SUBTITLE);
                }
            } else if (value.TITLE_TYPE === 'ALTERNATIVE_COVER_TITLE') {
                if (value.hasOwnProperty('title_element') && value.title_element !== null) {
                    $('.add_alternative_title_btn i').removeClass('fa-hexagon-plus');
                    $('.add_alternative_title_btn i').addClass('fa-hexagon-minus');
                    $('.add_alternative_title_btn span').text('Αφαίρεση εναλλακτικού τίτλου');
                    $(".alternative_title_group :input").removeAttr('disabled');
                    $(".alternative_title_group").show();
                    $('#alternative_title').val(value.title_element.TITLE_TEXT);
                    $('#alternative_subtitle').val(value.title_element.SUBTITLE);
                }
            }
        });
    }
	if (data.hasOwnProperty('TRANSLATED') && data.TRANSLATED === 1) {
		$('#translated').iCheck('check');
		$(".original_language_group :input").removeAttr('disabled');
        $(".original_language_group").show();		
    } 
	if (data.hasOwnProperty('languages')) {
        var languageItems = [];
        $.each(data['languages'], function (key, value) {
            if (value.LANG_ROLE === 'ORIGINAL_LANGUAGE') {
                $('#original_language_id').val(value.LANG_CODE).trigger('change');
            } else if (value.LANG_ROLE === 'LANGUAGE_OF_TEXT') {
                languageItems.push(value.LANG_CODE);
            }
        });
        $('#language_id').val(languageItems).trigger('change');
    }
    if (data.hasOwnProperty('publishing_detail') && data.publishing_detail !== null) {
        $('#country').val(data.publishing_detail.COUNTRY_OF_PUBLICATION).trigger('change');
        if (data['publishing_detail'].hasOwnProperty('city') && data.publishing_detail.city !== null) {
            $('#city').val(data.publishing_detail.city.CITY);
        }
        if (data['publishing_detail'].hasOwnProperty('dates')) {
            $.each(data.publishing_detail.dates, function (key, value) {
                var date = '';
                if (value.DAY !== '' && value.DAY !== null) {
                    value.DAY = parseInt(value.DAY);
                    value.MONTH = parseInt(value.MONTH);
                    date = (Math.floor(value.DAY / 10) === 0 ? '0' + value.DAY : value.DAY) + '/' + (Math.floor(value.MONTH / 10) === 0 ? '0' + value.MONTH : value.MONTH) + '/' + value.YEAR;
                } else if (value.MONTH !== '' && value.MONTH !== null) {
                    value.MONTH = parseInt(value.MONTH);
                    date = (Math.floor(value.MONTH / 10) === 0 ? '0' + value.MONTH : value.MONTH) + '/' + value.YEAR;
                } else {
                    date = value.YEAR;
                }
                if (value.DATE_ROLE === 'FIRST_PUBLICATION_DATE') {
                    $('#first_publication_date').val(date);
                } else if (value.DATE_ROLE === 'PUBLICATION_DATE') {
                    $('#publication_date').val(date);
                } else if (value.DATE_ROLE === 'TRANSFER_DATE') {
                    $('#rights_date').val(date);
                    if(date === 3000 || date === '3000' || date === 1900 || date === '1900'){
                        $('.rights-date-group').hide();
                    }
                    if(date === 3000  || date === '3000'){
                        $('#rights_id').val('no-expiration').trigger('change');
                    }else if(date === 1900 || date === '1900'){
                        $('#rights_id').val('expired').trigger('change');
                    }
                } else if (value.DATE_ROLE === 'DELETION_DATE') {
                    $('#deletion_date').val(date);
                }
            });
        }
    }
    if (data.hasOwnProperty('edition') && data.edition !== null) {
        $('#publication_number').val(data.edition.EDITION_NUMBER);
        if (data['edition'].hasOwnProperty('edition_statement') && data.edition.edition_statement !== null) {
            $('#publication_description').val(data.edition.edition_statement.STATEMENT);
        }
        if (data['edition'].hasOwnProperty('edition_types')) {
            var editionTypes = [];
            $.each(data.edition.edition_types, function (key, value) {
                editionTypes.push(value.editionTypes);
            });
            $('#edition_type').val(editionTypes).trigger('change');
        }
    }

    if (data.hasOwnProperty('extent_info') && data.extent_info !== null) {
        if (data['extent_info'].hasOwnProperty('ancillary_content')) {
            var acnillaryContent = [];
            $.each(data.extent_info.ancillary_content, function (key, value) {
                acnillaryContent.push(value.ANCILLARY_CONTENT_TYPE);
            });
            $('#ancillary_content').val(acnillaryContent).trigger('change');
        }
    }

    if (data.hasOwnProperty('collection_product') && data.collection_product !== null) {
        if (data['collection_product'].hasOwnProperty('collection') && data['collection_product'].COLLECTION_ID !== null) {
            var collection = data.collection_product.collection;
            $("#collection_id").empty().append('<option selected value="' + collection.ID + '">' + collection.COLLECTION_TITLE + '</option>');
            $("#collection_id").select2('data', {
                id: collection.ID,
                text: collection.COLLECTION_TITLE
            });
            $('#collection_title').val(collection.COLLECTION_TITLE);
            if (data['collection_product'].hasOwnProperty('COLLECTION_ID') && data.collection_product.COLLECTION_ID !== null) {
                $('#collection_title').attr('disabled', 'disabled');
                $('#issn').attr('disabled', 'disabled');
            }
            if (collection.hasOwnProperty('issn')) {
                if (collection.issn !== null) {
                    $('#issn').val(collection.issn.ID_VALUE);
                }
            }
			if (data.collection_product.hasOwnProperty('SEQUENCE_NUMBER')) {
				$('#sequence_number').val(data.collection_product.SEQUENCE_NUMBER);
			}
        }
        $('#collection_id').removeAttr('disabled');

    }

    if (data.hasOwnProperty('related_products')) {
        $.each(data.related_products, function (key, value) {
            if (key === 0) {
                $('#product_relation_type_1').val(data.related_products[0].RELATION_TYPE).trigger('change');
                $('#product_relation_isbn_1').val(data.related_products[0].ID_VALUE);
            } else {
                addRelatedProductRow();
                $('#product_relation_type_' + (window.product_relation_id - 1)).val(value.RELATION_TYPE).trigger('change');
                $('#product_relation_isbn_' + (window.product_relation_id - 1)).val(value.ID_VALUE);
            }
        });
    }

    if (data.hasOwnProperty('award_achievements')) {
        $.each(data.award_achievements, function (key, value) {
            if (key === 0) {
                $("#award_id_1").empty().append('<option selected value="' + data.award_achievements[0].AWARD_ID + '">' + data.award_achievements[0].award.NAME + '</option>');
                $("#award_id_1").select2('data', {
                    id: data.award_achievements[0].AWARD_ID,
                    text: data.award_achievements[0].award.NAME
                });
                $('#award_year_1').val(data.award_achievements[0].YEAR);
                $('#achievement_id_1').val(data.award_achievements[0].ACHIEVEMENT).trigger('change');
            } else {
                addAwardRow();
                $('#award_id_' + (window.award_id - 1)).empty().append('<option selected value="' + value.AWARD_ID + '">' + value.award.NAME + '</option>');
                $('#award_id_' + (window.award_id - 1)).select2('data', {
                    id: value.AWARD_ID,
                    text: value.award.NAME
                });
                $('#award_year_' + (window.award_id - 1)).val(value.YEAR);
                $('#achievement_id_' + (window.award_id - 1)).val(value.ACHIEVEMENT).trigger('change');
            }
        });
    }
    var productType = '';
    if((data.PRODUCT_FORM).startsWith('B')){
        $('#book_type').val('printed').trigger('change');
        productType = 'printed';
    }else if((data.PRODUCT_FORM).startsWith('E')){
        $('#book_type').val('ebook').trigger('change');
        productType = 'ebook';
    }else if((data.PRODUCT_FORM).startsWith('A')){
        $('#book_type').val('audiobook').trigger('change');
        productType = 'audiobook';
    }else{
        $('#book_type').val('set').trigger('change');
        productType = 'set';
    }
    //$('#book_type').val(data.PRODUCT_TYPE).trigger('change');
    if (productType === 'ebook') {
        $('.printed-group, .audiobook-group, .set-group').hide();
        $('.printed-group :input, .audiobook-group :input, .set-group :input').val('').trigger('change');
        $(".printed-group :input").attr('disabled', 'disabled');
        $(".set-group :input").attr('disabled', 'disabled');
        $(".audiobook-group :input").attr('disabled', 'disabled');
        $(".ebook-group :input").removeAttr('disabled');
        $('.ebook-group').show();

        $('#ebook_format').val(data.PRODUCT_FORM).trigger('change');
        if (data.hasOwnProperty('product_form_detail') && data.product_form_detail !== null) {
            $('#ebook_type').val(data.product_form_detail.FORM_DETAIL).trigger('change');
        }
        if (data.hasOwnProperty('extent_info') && data.extent_info !== null) {
            if (data['extent_info'].hasOwnProperty('extents')) {
                $.each(data.extent_info.extents, function (key, value) {
                    if (value.EXTENT_TYPE === 'FILESIZE') {
                        $('#ebook_filesize').val(parseInt(value.VALUE));
                    } else if (value.EXTENT_TYPE === 'PRINT_COUNTERPART_PAGE_COUNT') {
                        $('#ebook_printable_pages').val(parseInt(value.VALUE));
                    }/* else if (value.EXTENT_TYPE === 'SALES_COUNT') {
                        $('#ebook_sales_count').val(parseInt(value.VALUE));
                    }*/
                });
            }
        }
        $('#ebook_sales_count').val(data.COPIES);

        if (data.hasOwnProperty('protection') && data.protection !== null) {
            $('#ebook_protection').val(data.protection.EPUB_PROTECTION).trigger('change');
        }
        if (data.hasOwnProperty('usages')) {
            var usagesArray = [];
            $.each(data.usages, function (key, value) {
                if (value.USAGE_STATUS === 'PROHIBITED') {
                    usagesArray.push(value.USAGE_TYPE);
                }
            });
            $('#ebook_prohibited').val(usagesArray).trigger('change');
        }
        if (data.hasOwnProperty('product_form_feature') && data.product_form_feature !== null) {
            $('#ebook_accessibility').val(data.product_form_feature.VALUE).trigger('change');
        }
        if (data.hasOwnProperty('isTemp') && data['isTemp'] === true){
			$('#ebook_sales_count').removeAttr('readonly', 'readonly');
		}else{
			if($.inArray('EDITOR_FIELDS', ddVariables.permissions) === -1){
				$('#ebook_sales_count').attr('readonly', 'readonly');
				if($('#ebook_sales_count').val() === ''){
					$('#ebook_sales_count').removeAttr('readonly', 'readonly');
				}
			}
		}
    } else if (productType === 'audiobook') {
        $('.printed-group, .ebook-group, .set-group').hide();
        $('.printed-group :input, .ebook-group :input, .set-group :input').val('').trigger('change');
        $(".printed-group :input").attr('disabled', 'disabled');
        $(".set-group :input").attr('disabled', 'disabled');
        $(".ebook-group :input").attr('disabled', 'disabled');
        $(".audiobook-group :input").removeAttr('disabled');
        $('.audiobook-group').show();

        $('#audiobook_format').val(data.PRODUCT_FORM).trigger('change');
        if (data.hasOwnProperty('product_form_detail') && data.product_form_detail !== null) {
            $('#audiobook_type').val(data.product_form_detail.FORM_DETAIL).trigger('change');
        }
        if (data.hasOwnProperty('extent_info') && data.extent_info !== null) {
            if (data['extent_info'].hasOwnProperty('extents')) {
                $.each(data.extent_info.extents, function (key, value) {
                    if (value.EXTENT_TYPE === 'FILESIZE') {
                        $('#audiobook_filesize').val(parseInt(value.VALUE));
                    } else if (value.EXTENT_TYPE === 'DURATION') {
                        $('#audiobook_filelength').val(parseInt(value.VALUE));
                    }
                });
            }
        }
    } else if (productType === 'set') {
        $('.printed-group, .ebook-group, .audiobook-group').hide();
        $('.printed-group :input, .ebook-group :input, .audiobook-group :input').val('').trigger('change');
        $(".printed-group :input").attr('disabled', 'disabled');
        $(".audiobook-group :input").attr('disabled', 'disabled');
        $(".ebook-group :input").attr('disabled', 'disabled');
        $(".set-group :input").removeAttr('disabled');
        $('.set-group').show();

        $('#set_format').val(data.PRODUCT_FORM).trigger('change');
        if (data.hasOwnProperty('measures')) {
            $.each(data.measures, function (key, value) {
                if (value.MEASURE_TYPE === 'HEIGHT') {
                    $('#set_height').val(value.VALUE);
                } else if (value.MEASURE_TYPE === 'THICKNESS') {
                    $('#set_depth').val(value.VALUE);
                } else if (value.MEASURE_TYPE === 'UNIT_WEIGHT') {
                    $('#set_weight').val(value.VALUE);
                } else if (value.MEASURE_TYPE === 'WIDTH') {
                    $('#set_width').val(value.VALUE);
                }
            });
        }
        if (data.hasOwnProperty('extent_info') && data.extent_info !== null) {
            if (data['extent_info'].hasOwnProperty('extents')) {
                $.each(data.extent_info.extents, function (key, value) {
                    if (value.EXTENT_TYPE === 'MAIN_CONTENT_PAGE_COUNT') {
                        $('#set_pages').val(parseInt(value.VALUE));
                    }
                });
            }
        }
    } else if (productType === 'printed') {
        $('#book_binding').val(data.PRODUCT_FORM).trigger('change');
        $('#first_edition_copies').val(data.COPIES);
        $('#volume').val(data.VOLUME);
        $('#total_volumes').val(data.TOTAL_VOLUMES);
        if (data.hasOwnProperty('measures')) {
            $.each(data.measures, function (key, value) {
                if (value.MEASURE_TYPE === 'HEIGHT') {
                    $('#height').val(value.VALUE);
                } else if (value.MEASURE_TYPE === 'THICKNESS') {
                    $('#depth').val(value.VALUE);
                } else if (value.MEASURE_TYPE === 'UNIT_WEIGHT') {
                    $('#weight').val(value.VALUE);
                } else if (value.MEASURE_TYPE === 'WIDTH') {
                    $('#width').val(value.VALUE);
                }
            });
        }
        if (data.hasOwnProperty('extent_info') && data.extent_info !== null) {
            if (data['extent_info'].hasOwnProperty('extents')) {
                $.each(data.extent_info.extents, function (key, value) {
                    if (value.EXTENT_TYPE === 'MAIN_CONTENT_PAGE_COUNT') {
                        $('#printed_pages').val(parseInt(value.VALUE));
                    }
                });
            }
        }
        if($('#first_edition_copies').val() !== '' && $.inArray('EDITOR_FIELDS', ddVariables.permissions) === -1){
            $('#first_edition_copies').attr('readonly', 'readonly');
        }
    }
    if (data.hasOwnProperty('market_supply_info')) {
        $.each(data.market_supply_info, function (key, value) {
            if (value.supply_detail.SUPPLIER_ROLE == 'SR_09' ){
                $('#book_trading_type').val(value.PUBLISHING_STATUS).trigger('change');
				
                if (value.hasOwnProperty('supply_detail') && value.supply_detail !== null){
                    $('#book_trading_role').val(value.supply_detail.SUPPLIER_ROLE).trigger('change');
                    $('#trading_availability').val(value.supply_detail.PRODUCT_AVAILABILITY).trigger('change');
                    if (value['supply_detail'].hasOwnProperty('party') && value.supply_detail.party !== null) {
                        var party = value.supply_detail.party;
                        $('#book_trading_party_id').empty().append('<option selected value="' + party.PARTY_ID + '">' + party.PARTY_NAME + '</option>');
                        $('#book_trading_party_id').select2('data', {
                            id: party.PARTY_ID,
                            text: party.PARTY_NAME
                        });
                    }
                    if (value['supply_detail'].hasOwnProperty('supply_date') && value.supply_detail.supply_date !== null) {
                        var d = value.supply_detail.supply_date;
                        var date = '';
                        if (d.DAY !== '' && d.DAY !== null) {
                            d.DAY = parseInt(d.DAY);
                            d.MONTH = parseInt(d.MONTH);
                            date = (Math.floor(d.DAY / 10) === 0 ? '0' + d.DAY : d.DAY) + '/' + (Math.floor(d.MONTH / 10) === 0 ? '0' + d.MONTH : d.MONTH) + '/' + d.YEAR;
                        } else if (d.MONTH !== '' && d.MONTH !== null) {
                            d.MONTH = parseInt(d.MONTH);
                            date = (Math.floor(d.MONTH / 10) === 0 ? '0' + d.MONTH : d.MONTH) + '/' + d.YEAR;
                        } else {
                            date = d.YEAR;
                        }
                        $('#trading_start_date').val(date);
                    }
                    if (value['supply_detail'].hasOwnProperty('pricing') && value.supply_detail.pricing !== null) {
                        var pricing = value.supply_detail.pricing;						
                        $('#trading_price_currency').val(pricing.CURRENCY_CODE).trigger('change');
                        $('#trading_price_type').val(pricing.PRICE_TYPE).trigger('change');
						$('#book_trading_price_type').val(pricing.PRICING_TYPE).trigger('change');
						console.log("TEST:",$('#book_trading_price_type' ).val());
						if ($('#book_trading_price_type').val() === 'FREE') {
							console.log($('#book_trading_price_type').val());
							$('.price-group :input').val('').trigger('change');
							$('.price-group :input').attr('disabled', 'disabled');
							$('.price-group').hide();
							$('.price-group :input').each(function () {
								$(this).parsley().reset();
							});
							$('#book_trading_price_type').val('FREE').trigger('change');
						} else if ($('#book_trading_price_type').val() === 'UNPRICED') {
							$('.price-group :input').val('').trigger('change');
							$('.price-group :input').attr('disabled', 'disabled');
							$('.price-group').hide();
							$('.price-group :input').each(function () {
								$(this).parsley().reset();
							});
							$('#book_trading_price_type').val('UNPRICED').trigger('change');
						} else if ($('#book_trading_price_type').val() === 'SUBSCRIPTION') {
							$('.price-group :input').val('').trigger('change');
							$('.price-group :input').attr('disabled', 'disabled');
							$('.price-group').hide();
							$('.price-group :input').each(function () {
								$(this).parsley().reset();
							});
							$('#book_trading_price_type').val('SUBSCRIPTION').trigger('change');
						}
						if($('#book_trading_type').val() != 'B03'){
							$('#book_trading_price_type').attr('disabled', 'disabled');
						}else{
							$('#book_trading_price_type').removeAttr('disabled', 'disabled');
						}
                        var date = '';
                        if (pricing.UNTIL_DAY !== '' && pricing.UNTIL_DAY !== null) {
                            pricing.UNTIL_DAY = parseInt(pricing.UNTIL_DAY);
                            pricing.UNTIL_MONTH = parseInt(pricing.UNTIL_MONTH);
                            date = (Math.floor(pricing.UNTIL_DAY / 10) === 0 ? '0' + pricing.UNTIL_DAY : pricing.UNTIL_DAY) + '/' + (Math.floor(pricing.UNTIL_MONTH / 10) === 0 ? '0' + pricing.UNTIL_MONTH : pricing.UNTIL_MONTH) + '/' + pricing.UNTIL_YEAR;
                        } else if (pricing.UNTIL_MONTH !== '' && pricing.UNTIL_MONTH !== null) {
                            pricing.UNTIL_MONTH = parseInt(pricing.UNTIL_MONTH);
                            date = (Math.floor(pricing.UNTIL_MONTH / 10) === 0 ? '0' + pricing.UNTIL_MONTH : pricing.UNTIL_MONTH) + '/' + pricing.UNTIL_YEAR;
                        } else {
                            date = pricing.UNTIL_YEAR;
                        }
                        $('#price_valid_until_date').val(date).trigger('change');
                        if (pricing.hasOwnProperty('tax') && pricing.tax !== null) {
                            $('#price_vat').val(parseInt(pricing.tax.TAX_RATE_PERCENT));
                        }
                        if (pricing.hasOwnProperty('amount') && pricing.amount !== null) {
                            $('#current_price').val(pricing.amount.PRICE_AMOUNT);
                        }
                    }
                }
            } else {
                addSupplierRow();
                if (value.hasOwnProperty('supply_detail') && value.supply_detail !== null) {
                    $('#book_trading_role_' + (window.supplier_id - 1)).val(value.supply_detail.SUPPLIER_ROLE).trigger('change');
                    $('#trading_availability_' + (window.supplier_id - 1)).val(value.supply_detail.PRODUCT_AVAILABILITY).trigger('change');
                    if (value['supply_detail'].hasOwnProperty('party') && value.supply_detail.party !== null) {
                        var party = value.supply_detail.party;
                        $('#book_trading_party_id_' + (window.supplier_id - 1)).empty().append('<option selected value="' + party.PARTY_ID + '">' + party.PARTY_NAME + '</option>');
                        $('#book_trading_party_id_' + (window.supplier_id - 1)).select2('data', {
                            id: party.PARTY_ID,
                            text: party.PARTY_NAME
                        });
                    }
                    if (value['supply_detail'].hasOwnProperty('supply_date') && value.supply_detail.supply_date !== null) {
                        var d = value.supply_detail.supply_date;
                        var date = '';
                        if (d.DAY !== '' && d.DAY !== null) {
                            d.DAY = parseInt(d.DAY);
                            d.MONTH = parseInt(d.MONTH);
                            date = (Math.floor(d.DAY / 10) === 0 ? '0' + d.DAY : d.DAY) + '/' + (Math.floor(d.MONTH / 10) === 0 ? '0' + d.MONTH : d.MONTH) + '/' + d.YEAR;
                        } else if (d.MONTH !== '' && d.MONTH !== null) {
                            d.MONTH = parseInt(d.MONTH);
                            date = (Math.floor(d.MONTH / 10) === 0 ? '0' + d.MONTH : d.MONTH) + '/' + d.YEAR;
                        } else {
                            date = d.YEAR;
                        }
                        $('#trading_start_date_' + (window.supplier_id - 1)).val(date);
                    }
                    if (value['supply_detail'].hasOwnProperty('pricing') && value.supply_detail.pricing !== null) {
                        var pricing = value.supply_detail.pricing;
                        $('#trading_price_currency_' + (window.supplier_id - 1)).val(pricing.CURRENCY_CODE).trigger('change');
                        $('#trading_price_type_' + (window.supplier_id - 1)).val(pricing.PRICE_TYPE).trigger('change');
						$('#book_trading_price_type_' + (window.supplier_id - 1)).val(pricing.PRICING_TYPE).trigger('change');
						console.log("TEST:",$('#book_trading_price_type_' + (window.supplier_id - 1)).val());
						if ($('#book_trading_price_type_' + (window.supplier_id - 1)).val() === 'FREE') {
							console.log($('#book_trading_price_type_' + (window.supplier_id - 1)).val());
							$('.price-group-' + (supplier_id - 1) + ' :input').val('').trigger('change');
							$('.price-group-' + (supplier_id - 1) + ' :input').attr('disabled', 'disabled');
							$('.price-group-' + (supplier_id - 1)).hide();
							$('.price-group-' + (supplier_id - 1) + ' :input').each(function () {
								$(this).parsley().reset();
							});
							$('#book_trading_price_type_' + (window.supplier_id - 1)).val('FREE').trigger('change');
						} else if ($('#book_trading_price_type_' + (window.supplier_id - 1)).val() === 'UNPRICED') {
							$('.price-group-' + (supplier_id - 1) + ' :input').val('').trigger('change');
							$('.price-group-' + (supplier_id - 1) + ' :input').attr('disabled', 'disabled');
							$('.price-group-' + (supplier_id - 1)).hide();
							$('.price-group-' + (supplier_id - 1) + ' :input').each(function () {
								$(this).parsley().reset();
							});
							$('#book_trading_price_type_' + (window.supplier_id - 1)).val('UNPRICED').trigger('change');
						} else if ($('#book_trading_price_type_' + (window.supplier_id - 1)).val() === 'SUBSCRIPTION') {
							$('.price-group-' + (supplier_id - 1) + ' :input').val('').trigger('change');
							$('.price-group-' + (supplier_id - 1) + ' :input').attr('disabled', 'disabled');
							$('.price-group-' + (supplier_id - 1)).hide();
							$('.price-group-' + (supplier_id - 1) + ' :input').each(function () {
								$(this).parsley().reset();
							});
							$('#book_trading_price_type_' + (window.supplier_id - 1)).val('SUBSCRIPTION').trigger('change');
						}
						if($('#book_trading_type').val() != 'B03'){
							$('#book_trading_price_type').attr('disabled', 'disabled');
						}else{
							$('#book_trading_price_type').removeAttr('disabled', 'disabled');
						}
                        var date = '';
                        if (pricing.UNTIL_DAY !== '' && pricing.UNTIL_DAY !== null) {
                            pricing.UNTIL_DAY = parseInt(pricing.UNTIL_DAY);
                            pricing.UNTIL_MONTH = parseInt(pricing.UNTIL_MONTH);
                            date = (Math.floor(pricing.UNTIL_DAY / 10) === 0 ? '0' + pricing.UNTIL_DAY : pricing.UNTIL_DAY) + '/' + (Math.floor(pricing.UNTIL_MONTH / 10) === 0 ? '0' + pricing.UNTIL_MONTH : pricing.UNTIL_MONTH) + '/' + pricing.UNTIL_YEAR;
                        } else if (pricing.UNTIL_MONTH !== '' && pricing.UNTIL_MONTH !== null) {
                            pricing.UNTIL_MONTH = parseInt(pricing.UNTIL_MONTH);
                            date = (Math.floor(pricing.UNTIL_MONTH / 10) === 0 ? '0' + pricing.UNTIL_MONTH : pricing.UNTIL_MONTH) + '/' + pricing.UNTIL_YEAR;
                        } else {
                            date = pricing.UNTIL_YEAR;
                        }
                        $('#price_valid_until_date_' + (window.supplier_id - 1)).val(date).trigger('change');
                        if (pricing.hasOwnProperty('tax') && pricing.tax !== null) {
                            $('#price_vat_' + (window.supplier_id - 1)).val(parseInt(pricing.tax.TAX_RATE_PERCENT));
                        }
                        if (pricing.hasOwnProperty('amount') && pricing.amount !== null) {
                            $('#current_price_' + (window.supplier_id - 1)).val(pricing.amount.PRICE_AMOUNT);
                        }
                    }
                }
            }
        });
    }
    if (data.hasOwnProperty('product_classification') && data.product_classification !== null) {
        if (data['product_classification'].hasOwnProperty('keywords')) {
            $.each(data.product_classification.keywords, function (key, value) {
                addKeywordRow(value.KEYWORD);
            });
        }
        if (data['product_classification'].hasOwnProperty('audiences')) {
            var audienceArray = [];
            $.each(data.product_classification.audiences, function (key, value) {
                audienceArray.push(value.AUDIENCE);
            });
            $('#audience_id').val(audienceArray).trigger('change');
        }
        if (data['product_classification'].hasOwnProperty('categories')) {
            $.each(data.product_classification.categories, function (key, value) {
                if (value.hasOwnProperty('thema_classification') && value.thema_classification !== null) {
                    addCategoryRow(value);
					
                    if (value.MAIN) {
                        $('#webcat').val('Τέχνες').trigger('change');						
                       // $('#webcat').val(value.thema_classification.WEBCAT).trigger('change');
                    }
                }
            });
        }
    }
    var hasBackCover = false;
    var hasFrontCover = false;
    if (data.hasOwnProperty('collateral_detail') && data.collateral_detail !== null) {
        if (data['collateral_detail'].hasOwnProperty('text_contents')) {
            $.each(data.collateral_detail.text_contents, function (key, value) {
                if (value.TEXT_TYPE === 'TT_03') { //perigrafh
                    if (value.hasOwnProperty('text') && value.text !== null) {
                        $('#title_description_1').summernote('code', value.text.TEXT_VALUE);
                    }
                } else if (value.TEXT_TYPE === 'TT_02') { //syntomi perigrafi
                    if (value.hasOwnProperty('text') && value.text !== null) {
                        $('#title_short_description_1').val(value.text.TEXT_VALUE);
                    }
                } else { //otidhpote allo poy exei prosthesei o xrhsths
                    addTextRow();
                    $('#text_type_' + (window.text_id - 1)).val(value.TEXT_TYPE).trigger('change');
                    if (value.hasOwnProperty('audience') && value.audience !== null) {
                        $('#text_audience_' + (window.text_id - 1)).val(value.audience.CONTENT_AUDIENCE).trigger('change');
                    }
                    if (value.hasOwnProperty('text') && value.text !== null) {
                        $('#title_description_' + (window.text_id - 1)).summernote('code', value.text.TEXT_VALUE);
                    }
                }
            });
        }
        if (data['collateral_detail'].hasOwnProperty('supporting_resources')) {
            var resources = data.collateral_detail.supporting_resources;
            $.each(resources, function (key, value) {
                if (value.hasOwnProperty('resource_version') && value.resource_version !== null) {
                    if (value.CONTENT_TYPE === 'RCT_02') {
                        hasBackCover = true;
                    } else if (value.CONTENT_TYPE === 'RCT_01') {
                        hasFrontCover = true;
                    }
                }
            });
        }
        if(data['collateral_detail'].hasOwnProperty('frontBase64')){
            const blob = dataURItoBlob(data.collateral_detail.frontBase64.base64, data.collateral_detail.frontBase64.type);
            blob.name = data.collateral_detail.frontBase64.fileName;
            window.frontCoverDropzone.addFile(blob);
        }
        if(data['collateral_detail'].hasOwnProperty('backBase64')){
            const blob = dataURItoBlob(data.collateral_detail.backBase64.base64, data.collateral_detail.backBase64.type);
            blob.name = data.collateral_detail.backBase64.fileName;
            window.backCoverDropzone.addFile(blob);
        }
    }
	
    if (!hasBackCover) { //hide the div containing the back cover if not exists
        $('.back-cover-img').remove();
    }
    if (hasFrontCover) { //add class has-image to front-cover dropzone to prevent from validating if front-cover exists
        $('#front_cover_upload').addClass('has-image');
        $('#front_cover_exists').val('1');
    }

    if (data.hasOwnProperty('contributors')) {
        if (data.hasOwnProperty('isTemp') && data['isTemp'] === true) {
            $.each(data.contributors, function (key, value) {
                var formData = [];
                var rolesString = '';
                var nameString = '';
                var nameTypeString = '';
                var isTranslator = false;
                var obj = {};
                if (value.hasOwnProperty('roles')) {
                    $.each(value.roles, function (key1, value1) {
                        obj = {
                            name: 'contr_role[]',
                            value: value1.ROLE
                        };
                        if (value1.hasOwnProperty('role_codelist') && value1.role_codelist !== null) {
                            rolesString += value1.role_codelist.ROLE_DESCRIPTION + ", ";
                        }
                        if (value1.ROLE === 'B06' || value1.ROLE === 'B05' || value1.ROLE === 'B08'|| value1.ROLE === 'B10') {
                            isTranslator = true;
                        }
                        formData.push(obj);
                    });
                }
                rolesString = rolesString.slice(0, -2);
                if(value.hasOwnProperty('contr_id') && value.contr_id !== null){
                    obj = {
                        name: 'contr_id',
                        value: value.contr_id
                    };
                    formData.push(obj);
                }
                if(value.hasOwnProperty('default_denomination_id') && value.default_denomination_id !== null){
                    obj = {
                        name: 'default_denomination_id',
                        value: value.default_denomination_id
                    };
                    formData.push(obj);
                }

                if (value.hasOwnProperty('denomination') && value.hasOwnProperty('denomination_type')) {
                    var nameType = '';
                    if (value.denomination_type === 'REAL_NAME') {
                        nameType = 'Πραγματικό όνομα'
                    } else if (value.denomination_type === 'PSEUDONYM') {
                        nameType = 'Ψευδώνυμο'
                    } else {
                        nameType = 'Μεταγραφή / Άλλη γραφή'
                    }
                    obj = {
                        name: 'denomination_type',
                        value: value.denomination_type
                    };
                    nameTypeString = nameType;
                    formData.push(obj);
                    obj = {
                        name: 'denomination',
                        value: value.denomination
                    };
                    nameString = value.denomination;
                    formData.push(obj);
                }
                if (value.hasOwnProperty('contr_name_default')) {
                    obj = {
                        name: "contr_name_default",
                        value: value.contr_name_default
                    };
                    formData.push(obj);
                }
                if (value.hasOwnProperty('contr_name')) {
                  $.each(value.contr_name, function (key, value){
                      obj = {
                          name: "contr_name["+key+"][name]",
                          value: value.name
                      };
                      formData.push(obj);
                      obj = {
                          name: "contr_name["+key+"][surname]",
                          value: value.surname
                      };
                      formData.push(obj);
                      obj = {
                          name: "contr_name["+key+"][father_name]",
                          value: value.father_name
                      };
                      formData.push(obj);
                      obj = {
                          name: "contr_name["+key+"][name_type]",
                          value: value.name_type
                      };
                      formData.push(obj);
                  });
                }
                if (value.hasOwnProperty('birth_year')) {
                    obj = {
                        name: "birth_year",
                        value: value.birth_year
                    };
                    formData.push(obj);
                }
                if (value.hasOwnProperty('death_year')) {
                    obj = {
                        name: "death_year",
                        value: value.death_year
                    };
                    formData.push(obj);
                }
                if (value.hasOwnProperty('contr_country')) {
                    obj = {
                        name: "contr_country",
                        value: value.contr_country
                    };
                    formData.push(obj);
                }
                if (value.hasOwnProperty('contr_isni')) {
                    obj = {
                        name: "contr_isni",
                        value: value.contr_isni
                    };
                    formData.push(obj);
                }
                if (value.hasOwnProperty('contr_photo')) {
                    obj = {
                        name: "contr_photo",
                        value: JSON.parse(value.contr_photo)
                    };
                    formData.push(obj);
                }
                if (value.hasOwnProperty('contr_type')) {
                    obj = {
                        name: "contr_type",
                        value: value.contr_type
                    };
                    formData.push(obj);
                }
                if (value.hasOwnProperty('contr_cv')) {
                    obj = {
                        name: "contr_cv",
                        value: value.contr_cv
                    };
                    formData.push(obj);
                }
                buildNewContrToArray(rolesString, nameTypeString, nameString, formData, isTranslator);
                $('.no-contrs-message').hide();
            });
        }else {
            $.each(data.contributors, function (key, value) {
                var formData = [];
                var rolesString = '';
                var nameString = '';
                var nameTypeString = '';
                var isTranslator = false;

                var obj = {};
                if (value.hasOwnProperty('roles')) {
                    $.each(value.roles, function (key1, value1) {
                        obj = {
                            name: 'contr_role[]',
                            value: value1.ROLE
                        };
                        if (value1.hasOwnProperty('role_codelist') && value1.role_codelist !== null) {
                            rolesString += value1.role_codelist.LabelGR + ", ";
                        }
                        if (value1.ROLE === 'B06' || value1.ROLE === 'B05' || value1.ROLE === 'B08' || value1.ROLE === 'B10') {
                            isTranslator = true;
                        }
                        formData.push(obj);
                    });
                }
                rolesString = rolesString.slice(0, -2);
                if (value.hasOwnProperty('denomination')) {
                    var nameType = '';
                    if (value.denomination.NAME_TYPE === 'REAL_NAME') {
                        nameType = 'Πραγματικό όνομα'
                    } else if (value.denomination.NAME_TYPE === 'PSEUDONYM') {
                        nameType = 'Ψευδώνυμο'
                    } else {
                        nameType = 'Μεταγραφή / Άλλη γραφή'
                    }
                    obj = {
                        name: 'denomination_type',
                        value: value.denomination.NAME_TYPE
                    };
                    nameTypeString = nameType;
                    formData.push(obj);
                    obj = {
                        name: 'denomination',
                        value: value.denomination.DENOMINATION
                    };
                    nameString = value.denomination.DENOMINATION;
                    formData.push(obj);
                }
                if (value.hasOwnProperty('contributor_party')) {
                    obj = {
                        name: 'contr_id',
                        value: value.contributor_party.CONTRIBUTOR_PARTY_ID
                    };
                    formData.push(obj);
                    obj = {
                        name: 'default_denomination_id',
                        value: value.contributor_party.DEF_DENOM_ID
                    };
                    formData.push(obj);
                    if (value['contributor_party'].hasOwnProperty('denominations')) {
                        $.each(value.contributor_party.denominations, function (key1, value1) {
                            if (value.CONTRIBUTOR_DENOMINATION_ID === value1.CONTRIBUTOR_DENOMINATION_ID) {
                                obj = {
                                    name: "contr_name_default",
                                    value: "default_name_existing_" + key1
                                };
                                formData.push(obj);
                            }
                        });
                    }
                }
                buildNewContrToArray(rolesString, nameTypeString, nameString, formData, isTranslator);
                $('.no-contrs-message').hide();
            });
        }
    }
}

function buildNewContrToArray(rolesString, nameTypeString, nameString, formData, isTranslator){
    var html = '';
    html += '<div class="contr-added card-body row ';
    if(isTranslator) {
        html += 'translator';
    }
    html += '" data-id="'+window.contr_id+'">';
    html += '<div class="col-sm-9 details-contr-array">';
    html += 'Ιδιότητες: <span id="roles_string">'+rolesString+'</span><br>';
    html +=  '<span class="name_type_string">'+nameTypeString+'</span>: <span id="name_string">'+nameString+'</span>';
    html += '</div>';
    html += '<div class="col-sm-3 list-inline list-items-contr-array text-right">';
    html += '<li class="list-inline-item">';
    html += '<button type="button" id="edit_contr_added" class="btn td-n c-deep-purple-500 cH-purple-200 fsz-md p-5  fl-r" title="Επεξεργασία"><i class="ti-pencil"></i></button>';
    html += '</li>';
    html += '<li class="list-inline-item">';
    html += '<button type="button" id="remove_contr_added" class="btn td-n cH-red-200 fsz-md p-5 fl-r" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
    html += '</li>';
    html += '</div>';
    html += '</div>';
    $('.contributors-list').append(html);

    $("div").find("[data-id='" + window.contr_id + "']").data("info", formData);
    window.contr_id++;
    resetContrForm();

}

function resetContrForm(){
    $('#contr_id').empty();
    $('#contr_id').val('').trigger('change');
    $('#contr_role').val('').trigger('change');
    $('#contr_type').val('PERSON').trigger('change');
    $('#contr_type').removeAttr('disabled');
    $('#author_id').val('');
    $('#contr_type').val('PERSON').trigger('change');
    $('#contr_type').removeAttr('disabled');
    $('#contr_isni').prop('disabled',false);
    $('#contr_isni').val('');
    $('.contr-name-group-default').show();
    $('.contr-name-group-default :input').removeAttr('disabled');
    $('.existing-name-group').remove();
    $('.existing-contr-names').hide();
    $('.for-approval-fields :input').removeAttr('disabled');
    $('.for-approval-fields').show();
    $('#default_name_1').iCheck('check');
    $('.contr-name-group').remove();
    $('.contr-name-group-default :input').parsley('reset');
    $('.contr-name-group-default :input').val('').trigger('change');
    $('#default_name_1').val('default_name_added_1');
    $('#contr_cv').summernote('reset');
    $('#added_contr_id').val('');
    Dropzone.forElement("#contr_photo").removeAllFiles(true);

    window.contr_name_id = 2;
}
var xCat = true;
function addCategoryRow(thema){
    if (thema.thema_classification.CODE_DESCRIPTION !== '') {
        var html = '';
        html += '<span class="category-item row align-items-center ';
        if(thema.MAIN){
            html += 'is-main-category';
        }
        html += '" data-category-id='+thema.THEMA_CODE+'>';
		if(thema.MAIN){
            html += '<p><b><u>Κύρια Κατηγορία</u></b></p>';							
        }else{
			if(xCat == true) {
			html += '<p><b><u>Πρόσθετες Κατηγορίες</u></b></p>';
			xCat = false;
		}
		}		
        html += '<span class="category-item-text text-left col-sm-9 ';
        if(thema.MAIN){
            html += 'node-main';
        }
        html += '" ';
        if(thema.MAIN){
            html += 'main="true"';
        }
        html += '>';
        html += $.trim(thema.thema_classification.CODE_DESCRIPTION);
        html += '</span>';
        html += '<div class="col-sm-1">';
        html += '<button type="button" id="remove_category" class="btn td-n  cH-red-200 fsz-md" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
        html += '</div>';
		if(thema.MAIN){
			if(thema.thema_classification.NOTES != null){
			html += '<div class="category-item-note"><div><p>'+thema.thema_classification.NOTES+'</p></div>';
			html += '<div><hr class="solid"/></div></div>';
			}
			
		}
        html += '</span>';		
        if(thema.MAIN){
            $('.selected-categories').prepend(html);
        }else {
            $('.selected-categories').append(html);
        }
    }
}

function addKeywordRow(value){
    if ($.trim(value) !== '') {
        var html = '';
        html += '<span class="keyword-item row align-items-center">';
        html += '<span class="keyword-item-text text-left col-sm-10">';
        html += $.trim(value);
        html += '</span>';
        html += '<div class="col-sm-1">';
        html += '<button type="button" id="remove_keyword" class="btn td-n  cH-red-200 fsz-md" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
        html += '</div>';
        html += '</span>';
        $('.keyword-box').append(html);
        $('#keyword').val('');
    }
}

$("#addRow").click(function () {
    addRelatedProductRow();
});

function addRelatedProductRow(){
    $('.product-relation-group-first :input').attr('data-parsley-required', true);

    var html = '';
    html += '<div class="row form-group product-relation-group">';
    //html += '<div class="col-sm-3"></div>';
    html += '<div class="col-sm-6">';
    html += '<div class="product-relation-cont-'+window.product_relation_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-errors-container="#select-error12-'+window.product_relation_id+'" data-parsley-class-handler=".product-relation-cont-'+window.product_relation_id+'" id="product_relation_type_'+window.product_relation_id+'" name="product_relation_type[]" data-parsley-required="true">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error12-'+window.product_relation_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-5">';
    html += '<input id="product_relation_isbn_'+window.product_relation_id+'" class="form-control" name="product_relation_isbn[]" maxlength="255" data-parsley-required="true"/>';
    html += '</div>';
    html += '<div class="col-sm-1">';
    html += '<button type="button" id="remove_product_relation" class="btn td-n  cH-red-200 fsz-md p-5" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
    html += '</div>';
    $('#newRow').append(html);

    $('#product_relation_type_'+window.product_relation_id).select2({
        placeholder: "Επιλέξτε είδος σχέσης",
        data: window.productRelation,
        width:"resolve",
        allowClear: true
    });

    $('#product_relation_isbn_'+window.product_relation_id).change(function(e){
        $(this).parsley().removeError('isbnFormatError');
        if(!window.check13Isbn($(this).val())){
            $(this).parsley().addError('isbnFormatError', {message: 'Λάθος μορφή ISBN'});
        }
    });
    window.product_relation_id++;
}
// remove row
$(document).on('click', '#remove_product_relation', function () {
    $(this).closest('.product-relation-group').remove();
    if($('#newRow .product-relation-group').length === 0){
        $('.product-relation-group-first :input').removeAttr('data-parsley-required');
        $.each($('.product-relation-group-first :input'), function(){
            $(this).parsley().reset();
        });
    }
});

$("#addRow-award").click(function () {
    addAwardRow();
});

function addAwardRow() {
    $('.award-group-first :input').attr('data-parsley-required', true);

    var html = '';
    html += '<div class="row form-group award-group">';
    //html += '<div class="col-sm-3"></div>';
    html += '<div class="col-sm-6">';
    html += '<div class="award-cont-'+window.award_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-required="true" data-parsley-errors-container="#select-error13-'+window.award_id+'" data-parsley-class-handler=".award-cont-'+window.award_id+'" id="award_id_'+window.award_id+'" name="award_id[]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error13-'+window.award_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-2">';
    html += '<input id="award_year_'+window.award_id+'" class="form-control" name="award_year[]" maxlength="255" data-parsley-required="true"/>';
    html += '</div>';
    html += '<div class="col-sm-3">';
    html += '<div class="achievement-cont-'+window.award_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-required="true" data-parsley-errors-container="#select-error14-'+window.award_id+'" data-parsley-class-handler=".achievement-cont-'+window.award_id+'" id="achievement_id_'+window.award_id+'" name="achievement_id[]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error14-'+window.award_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-1">';
    html += '<button type="button" id="remove_award" class="btn td-n  cH-red-200 fsz-md p-5" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
    html += '</div>';
    $('#newRow-award').append(html);

    initSelect2("#award_id_"+window.award_id, "Επιλέξτε βραβείο", window.selectAwardData);
    $('#achievement_id_'+window.award_id).select2({
        placeholder: "Επιλέξτε επίτευξη",
        data: window.achievements,
        width:"resolve",
        minimumResultsForSearch: -1,
        allowClear: true
    });
    window.award_id++;
}

$("#addRow-award-contr").click(function () {
    addAwardRowContr();
});

function addAwardRowContr() {
    $('.award-group-first :input').attr('data-parsley-required', true);

    var html = '';
    html += '<div class="row form-group award-group">';
    //html += '<div class="col-sm-3"></div>';
    html += '<div class="col-sm-6">';
    html += '<div class="award-cont-'+window.award_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-required="true" data-parsley-errors-container="#select-error13-'+window.award_id+'" data-parsley-class-handler=".award-cont-'+window.award_id+'" id="award_id_'+window.award_id+'" name="award_id[]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error13-'+window.award_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-2">';
    html += '<input id="award_year_'+window.award_id+'" class="form-control" name="award_year[]" maxlength="255" data-parsley-required="true"/>';
    html += '</div>';
    html += '<div class="col-sm-3">';
    html += '<div class="achievement-cont-'+window.award_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-required="true" data-parsley-errors-container="#select-error14-'+window.award_id+'" data-parsley-class-handler=".achievement-cont-'+window.award_id+'" id="achievement_id_'+window.award_id+'" name="achievement_id[]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error14-'+window.award_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-1">';
    html += '<button type="button" id="remove_award" class="btn td-n  cH-red-200 fsz-md p-5" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
    html += '</div>';
    $('#newRow-award').append(html);

    initSelect2("#award_id_"+window.award_id, "Επιλέξτε βραβείο", window.selectAwardData);
    $('#achievement_id_'+window.award_id).select2({
        placeholder: "Επιλέξτε επίτευξη",
        data: window.achievements,
        width:"resolve",
        minimumResultsForSearch: -1,
        allowClear: true
    });
    window.award_id++;
}

$(document).on('click', '#remove_award', function () {
    $(this).closest('.award-group').remove();
    if($('#newRow-award .award-group').length === 0){
        $('.award-group-first :input').removeAttr('data-parsley-required');
        $.each($('.award-group-first :input'), function(){
            $(this).parsley().reset();
        });
    }
});

$("#addRow-supplier").click(function () {
    addSupplierRow();
});

function addSupplierRow(){
    var html = '';
    html += '<div class="supplier-group">';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Είδος / Ρόλος <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-8">';
    html += '<div class="trading-role-cont-'+window.supplier_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-errors-container="#select-error28-'+window.supplier_id+'" data-parsley-required="true" data-parsley-class-handler=".trading-role-cont-'+window.supplier_id+'" id="book_trading_role_'+window.supplier_id+'" name=trading['+window.supplier_id+'][role]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error28-'+window.supplier_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-1">';
    html += '<button type="button" id="remove_supplier" class="btn td-n  cH-red-200 fsz-md p-5" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
    html += '</div>';
    html += '</div>';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Προμηθευτής <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-8">';
    html += '<div class="trading-imprint-cont-'+window.supplier_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-errors-container="#select-error29-'+window.supplier_id+'" data-parsley-required="true" data-parsley-class-handler=".trading-imprint-cont-'+window.supplier_id+'" id="book_trading_party_id_'+window.supplier_id+'" name="trading['+window.supplier_id+'][party_id]">';
    html += '</select>';
    html += '<div id="select-error29-'+window.supplier_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Διαθεσιμότητα προμηθευτή <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-8">';
    html += '<div class="trading-availability-cont-'+window.supplier_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-errors-container="#select-error30-'+window.supplier_id+'" data-parsley-required="true" data-parsley-class-handler=".trading-availability-cont-'+window.supplier_id+'" id="trading_availability_'+window.supplier_id+'" name="trading['+window.supplier_id+'][availability]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error30-'+window.supplier_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Ημερομηνία έναρξης διακίνησης ';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-8 form-group">';
    html += '<span class="fa fa-calendar form-control-icon"></span>';
    html += '<input type="text" class="form-control date-input" id="trading_start_date_'+window.supplier_id+'" name="trading['+window.supplier_id+'][start_date]" data-parsley-required="false" data-parsley-validate data-parsley-partial-date="" data-parsley-date-before="" data-parsley-trigger="change"/>';
    html += '</div>';
    html += '</div>';
	//-----------------------------------------------
	
	html += '<div class="trtype-group">';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Τιμή <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-8">';
    html += '<div class="trading-price-cont-'+window.supplier_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-errors-container="#select-error28-'+window.supplier_id+'" data-parsley-required="true" data-parsley-class-handler=".trading-price-cont-'+window.supplier_id+'" id="book_trading_price_type_'+window.supplier_id+'" name=book_trading['+window.supplier_id+'][price_type]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error28-'+window.supplier_id+'"></div>';
    html += '</div>';
    html += '</div>';
	html += '</div>';
	html += '</div>';
	
	//------------------------------------------------
    html += '<div class="price-group-'+window.supplier_id+'">';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Είδος τιμής <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-3">';
    html += '<div class="book-trading-price-type-cont-'+window.supplier_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-required="true" data-parsley-errors-container="#select-error32-'+window.supplier_id+'" data-parsley-class-handler=".book-trading-price-type-cont'+window.supplier_id+'" id="trading_price_type_'+window.supplier_id+'" name="trading['+window.supplier_id+'][price_type]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error32-'+window.supplier_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<label class="col-sm-2 text-right">';
    html += '<h6>';
    html += 'Ισχύει μέχρι';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-3 form-group">';
    html += '<span class="fa fa-calendar form-control-icon"></span>';
    html += '<input type="text" class="form-control date-input" id="price_valid_until_date_'+window.supplier_id+'" name="trading['+window.supplier_id+'][price_valid_until_date]" data-parsley-required="true" data-parsley-validate data-parsley-partial-date="" data-parsley-greater-than-publication="" data-parsley-trigger="change"/>';
    html += '</div>';
    html += '</div>';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Τρέχουσα τιμή <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-3">';
    html += '<input type="number" min="0" step="0.01" id="current_price_'+window.supplier_id+'" class="form-control" name="trading['+window.supplier_id+'][current_price]" data-parsley-trigger="focusout" data-parsley-required="true"/>';
    html += '</div>';
    html += '<label class="col-sm-2 text-right">';
    html += '<h6>';
    html += 'Νόμισμα <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-3">';
    html += '<div class="book-trading-price-currency-cont-'+window.supplier_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-required="true" data-parsley-errors-container="#select-error33-'+window.supplier_id+'" data-parsley-class-handler=".book-trading-price-currency-cont-'+window.supplier_id+'" id="trading_price_currency_'+window.supplier_id+'" name="trading['+window.supplier_id+'][price_currency]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error33-'+window.supplier_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Συντελεστής ΦΠΑ % <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-3">';
    html += '<input type="number" min="0" max="100" step="1" id="price_vat_'+window.supplier_id+'" class="form-control" name="trading['+window.supplier_id+'][price_vat]" value="6" data-parsley-required="true"/>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '<hr class="solid"/>';
    html += '</div>';

    $('#newRow-supplier').append(html);

    if($('#book_trading_type').val() === 'F00' || $('#book_trading_type').val() === 'B02'){
        $('.price-group-'+window.supplier_id+' :input').attr('disabled','disabled');
        $('.price-group-'+window.supplier_id).hide();
    }
	if($('#book_trading_type').val() != 'B03'){
		$('#book_trading_price_type_'+window.supplier_id).attr('disabled','disabled');
	}
    $('#current_price_'+window.supplier_id).change(function(e){
        $(this).parsley().validate();
    });

    $('#book_trading_role_'+window.supplier_id).select2({
        placeholder: "Επιλέξτε ρόλο",
        data: window.tradingRoles,
        width:"resolve",
        minimumResultsForSearch: -1,
    });
    initSelect2("#book_trading_party_id_"+window.supplier_id, "Επιλέξτε εκδοτικό οίκο", window.selectPartyData);
    $('#trading_availability_'+window.supplier_id).select2({
        placeholder: "Επιλέξτε διαθεσιμότητα",
        data: window.imprintAvailability,
        width:"resolve",
    });
    $("#trading_start_date_"+window.supplier_id).datetimepicker({
        format: "d/m/Y",
        timepicker:false,
        validateOnBlur:false,
        //minDate:0, //today
        scrollMonth: false,
        scrollInput: false
    });

    $("#trading_start_date_"+window.supplier_id).on("change",function(){
        $(this).parsley().validate();
    });
	
	$('#book_trading_price_type_'+window.supplier_id).select2({
            placeholder: "Επιλέξτε είδος",
            data: window.prodcutPriceType,
            width:"resolve",
            minimumResultsForSearch: -1,
    });
	$('#book_trading_price_type_'+window.supplier_id).select2('val', ["PRICED"]);
	
	if ($('#book_trading_type').val() === 'B03') {
		$('#newRow-supplier').on('change', '[id^=book_trading_price_type_]', function (e) {
			var supplier_id = this.id.split('_').pop();

			if ($(this).length > 0) {
				
				var value = $(this).val();
				console.log("Value:", value);

				if (value === 'UNPRICED' || value === 'FREE' || value === 'SUBSCRIPTION') {
					$('.price-group-' + supplier_id + ' :input').prop('disabled', true);
					$('.price-group-' + supplier_id).hide();
				} else {
					$('.price-group-' + supplier_id + ' :input').prop('disabled', false);
					$('.price-group-' + supplier_id).show();
				}
			} else {
				console.log("Element not found or doesn't exist");
			}
		});
	}

    $("#price_valid_until_date_"+window.supplier_id).datetimepicker({
        format: "d/m/Y",
        timepicker:false,
        validateOnBlur:false,
        //minDate:0, //today
        scrollMonth: false,
        scrollInput: false
    });

    $("#price_valid_until_date_"+window.supplier_id).on("change",function(){
        $(this).parsley().validate();
    });

    $("#trading_price_type_"+window.supplier_id).select2({
        placeholder: "Επιλέξτε τύπο",
        data: window.priceType,
        width:"resolve",
        minimumResultsForSearch: -1,
    });
    $('#trading_price_type_'+window.supplier_id).select2('val', ["PT_04"]);

    $('#trading_price_type_'+window.supplier_id).on('change', function (e) {
        $(this).closest('.supplier-group').find("[id^='price_valid_until_date']").parsley().validate();
        if($(this).val() === 'PT_03' || $(this).val() === 'PT_04') {
            if ($('#publication_date').val() !== '') {
                const dt = new Date(getFullDateFromPartial($('#publication_date').val()));
                dt.setMonth(dt.getMonth() + 18);
                let dateString = ((dt.getDate() > 9) ? dt.getDate() : ('0' + dt.getDate())) + '/' + ((dt.getMonth() > 8) ? (dt.getMonth() + 1) : ('0' + (dt.getMonth() + 1))) + '/' + dt.getFullYear();
                $(this).closest('.supplier-group').find("[id^='price_valid_until_date']").val(dateString);

            }
        }

        var priceValidUntilElem = $(this).closest('.supplier-group').find("[id^=price_valid_until_date_]");
        if($(this).val() === 'PT_03' || $(this).val() === 'PT_04' || $(this).val() === 'PT_13' || $(this).val() === 'PT_14') {
            priceValidUntilElem.attr('data-parsley-required',true);
        }else{
            priceValidUntilElem.removeAttr('data-parsley-required');
            priceValidUntilElem.parsley().reset();
        }
    });

    $("#trading_price_currency_"+window.supplier_id).select2({
        placeholder: "Επιλέξτε νόμισμα",
        data: window.currency,
        width:"resolve",
        minimumResultsForSearch: -1,
    });
    $('#trading_price_currency_'+window.supplier_id).select2('val', ["EUR"]);
    window.supplier_id++;
}
$(document).on('click', '#remove_supplier', function () {
    $(this).closest('.supplier-group').remove();
});

$("#addRow-text").click(function () {
    addTextRow();
});

function addTextRow(){
    var html = '';
    html += '<div class="text-group">';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Είδος κειμένου <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-8">';
    html += '<div class="text-type-cont-'+window.text_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-errors-container="#select-error34-'+window.text_id+'" data-parsley-class-handler=".text-type-cont-'+window.text_id+'" id="text_type_'+window.text_id+'" name="additional['+window.text_id+'][type]"  data-parsley-required="true">';
    html += '<option></option>'
    html += '</select>';
    html += '<div id="select-error34-'+window.text_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-1">';
    html += '<button type="button" id="remove_text" class="btn td-n  cH-red-200 fsz-md p-5" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
    html += '</div>';
    html += '</div>';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-3 text-right">';
    html += '<h6>';
    html += 'Προβολή / κοινό <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-8">';
    html += '<div class="text-audience-cont-'+window.text_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-errors-container="#select-error35-'+window.text_id+'" data-parsley-class-handler=".text-audience-cont-'+window.text_id+'" id="text_audience_'+window.text_id+'" name="additional['+window.text_id+'][audience]"  data-parsley-required="true">';
    html += '<option></option>'
    html += '</select>';
    html += '<div id="select-error35-'+window.text_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="row form-group">';
    html += '<div class="col-sm-3"></div>';
    html += '<div class="col-sm-8">';
    html += '<textarea id="title_description_'+window.text_id+'" name="additional['+window.text_id+'][description]" data-parsley-errors-container="#error-description-'+window.text_id+'" data-parsley-required="true"></textarea>';
    html += '<div id="error-description-'+window.text_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<hr class="solid"/>';
    html += '</div>';
    $('#newRow-text').append(html);

    window.textType = window.textType.filter(function( obj ) {
        return obj.id !== 'TT_03';
    });
    window.textType = window.textType.filter(function( obj ) {
        return obj.id !== 'TT_02';
    });

    $('#text_type_'+window.text_id).select2({
        placeholder: "Επιλέξτε είδος",
        data: window.textType,
        width:"resolve",
        minimumResultsForSearch: -1,
    });

    $('#text_audience_'+window.text_id).select2({
        placeholder: "Επιλέξτε κοινό",
        data: window.textAudience,
        width:"resolve",
        minimumResultsForSearch: -1,
    });
    $('#title_description_'+window.text_id).summernote({
        height: 250,
        placeholder: 'Περιγραφή...',
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript','fontname','color']],
            ['fontsize', ['fontsize']],
            ['para', ['ul', 'ol', 'paragraph','style','clear']],
            ['height', ['height']],
            ['insert', ['link', 'picture', 'video','hr']],
            ['table', ['table']],
            ['view', ['undo', 'redo','codeview', 'help']],
        ]
    });
    window.text_id++;
}
$(document).on('click', '#remove_text', function () {
    $(this).closest('.text-group').remove();
})

function dataURItoBlob(dataURI ,type) {
    'use strict'
    var byteString;
    dataURI = dataURI.replace(/ /g, '+');
    byteString = atob(dataURI);
    var content = new Array();
    for (var i = 0; i < byteString.length; i++) {
        content[i] = byteString.charCodeAt(i)
    }

    return new Blob([new Uint8Array(content)], {type: type});
}

function buildExistingContrNames(data, defDenomId){
    if(data.length > 0){
        $.each(data, function(key, value){
            var html = '';
            html += '<div class="row form-group existing-name-group">';
            html += '<input type="hidden" name="contr_name['+key+'][denom_id]" id="denom_id_'+key+'">';
            html += '<div class="col-sm-3">';
            html += '<div>';
            html += '<select  style="width:100%" class="form-control" id="existing_name_type_'+key+'" name="contr_name' +
                '['+key+'][name_type]">';
            html += '<option></option>';
            html += '<option value="REAL_NAME">Πραγματικό όνομα</option>';
            html += '<option value="PSEUDONYM">Ψευδώνυμο</option>';
            html += '<option value="TRANSLITERATED_NAME">Μεταγραφή / Άλλη γραφή</option>';
            html += '</select>';
            html += '</div>';
            html += '</div>';
            html += '<div class="col-sm-6">';
            html += '<input id="denomination_'+key+'" class="form-control" name="contr_name['+key+'][denomination]" maxlength="255" placeholder="Ονομασία"/>';
            html += '</div>';
            html += '<div class="col-sm-2 text-center">';
            html += '<input  class="flat" type="radio" name="contr_name_default" id="default_name_added_'+key+'" value="default_name_'+key+'">';
            html += '</div>';
            if($.inArray('CONTR_MERGE', ddVariables.permissions) > -1) {
                html += '<div class="col-sm-1">';
                html += '<button type="button" id="remove_contr_name_existing" class="btn td-n  cH-red-200 fsz-md p-5" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
                html += '</div>';
            }
            html += '</div>';

            $('.existing-contr-names').append(html);

            $('input#default_name_added_'+key).iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green'
            });

            $('#existing_name_type_'+key).select2({
                placeholder: "Επιλέξτε τύπο",
                minimumResultsForSearch: -1
            })
            $('#existing_name_type_'+key).val(value.NAME_TYPE).trigger('change');
            $('#denom_id_'+key).val(value.CONTRIBUTOR_DENOMINATION_ID);
            $('#denomination_'+key).val(value.DENOMINATION);
            if(value.CONTRIBUTOR_DENOMINATION_ID == defDenomId){
                $('#default_name_added_'+key).iCheck('check');
            }

            window.denominationsList.push({
                id: value.CONTRIBUTOR_DENOMINATION_ID,
                name: value.DENOMINATION
            });

            if($.inArray('CONTR_EDIT', ddVariables.permissions) === -1) {
                $('#existing_name_type_'+key).attr('disabled','disabled');
                $('#denomination_'+key).attr('readonly', 'readonly');
                $('input#default_name_added_'+key).attr('disabled', true);

            }
            window.contr_name_id++;
        })
    }
}

fillInContributor = function (data, object) {

    if(data.hasOwnProperty('denominations')){
        buildExistingContrNames(data.denominations, data.DEF_DENOM_ID);
    }
    if(data.hasOwnProperty('awards')){
/*        if(data.awards.length > 0){
            var value = data.awards[0];
            $('#achievement_id_1').val(value.ACHIEVEMENT).trigger('change');
            $('#award_year_1').val(value.YEAR).trigger('change');
            $("#award_id_1").empty().append('<option selected value="' + value.AWARD_ID + '">' + value.award.NAME + '</option>');
            $("#award_id_1").select2('data', {
                id: value.AWARD_ID,
                label: value.award.NAME
            });
            data.awards.shift();
        }*/
        $.each(data.awards, function (key, value){
            addAwardRowContr()
            $('#achievement_id_' + (window.award_id - 1)).val(value.ACHIEVEMENT).trigger('change');
            $('#award_year_' +(window.award_id - 1)).val(value.YEAR);
            $("#award_id_" +(window.award_id - 1)).empty().append('<option selected value="' + value.AWARD_ID + '">' + value.award.NAME + '</option>');
            $("#award_id_" +(window.award_id - 1)).select2('data', {
                id: value.AWARD_ID,
                label: value.award.NAME
            });
        });
    }
    if(data.COUNTRY !== null){
        $('#contr_country').val(data.COUNTRY).trigger('change');
    }

    if(data.RLTS !== null){
        if(data.RLTS == 0){
            $('#public_domain_status_yes').iCheck('check');
        }else{
            $('#public_domain_status_no').iCheck('check');
        }
    }else{
        if(data.DEATH_YEAR !== null){
            var currDate = new Date().getFullYear();
            console.log(currDate);
            if((currDate - 1) - data.DEATH_YEAR > 70){
                $('#public_domain_status_yes').iCheck('check');
            }else{
                $('#public_domain_status_no').iCheck('check');
            }
        }
    }

    if(data.hasOwnProperty('BIO_NOTE') && data.BIO_NOTE !== null){
        $('#contr_cv').summernote('code', data.BIO_NOTE);
    }

    if((data.PHOTO_0 !== null && data.PHOTO_0 === 1)
    || data.BIO_NOTE_0 !== null
    || data.BIRTH_YEAR_0 !== null
    || data.DEATH_YEAR_0 !== null
    || data.COUNTRY_0){
        $('.no-approvals-message').hide();
        if(data.BIRTH_YEAR_0 !== null){
            $('.approve_birth_year').show();
        }
        if(data.DEATH_YEAR_0 !== null){
            $('.approve_death_year').show();
        }
        if(data.COUNTRY_0 !== null){
            $('.approve_country').show();
            $('#contr_country_0').val(data.COUNTRY_0).trigger('change');
        }
        if(data.PHOTO_0 !== null){
            $('.approve_photo').show();
        }
        if(data.BIO_NOTE_0 !== null){
            $('.approve_cv').show();
            $('#contr_cv_0').html(data.BIO_NOTE_0);
        }
    }
}
fillInPub = function (data, object) {
    //console.log(JSON.parse(JSON.stringify(data)));
    //console.log(copydata);
    $('#party_name').val(data.PARTY_NAME);
    $('#party_type').val(data.PARTY_TYPE).trigger('change');
    if(data.PARTY_TYPE === 'PUBLISHER' ){
        $('.pub-imprints-group').show();
    }
	if(data.PARTY_TYPE === 'BOOKSELLER' ){
        $('.bookseller-group').show();
		$('.supplier-group').hide();
		$('.webservice-group').hide();
		$('.audioExcel-group').hide();
    }
    $('#party_piid_status').val(data.PIID_STATUS).trigger('change');
    $('#party_country').val(data.COUNTRY).trigger('change');
    $('#web_service_url').val(data.WEB_SERVICE_URL).trigger('change');

    if(data.hasOwnProperty('publishing_group') && data.publishing_group !== null){
        $("#publishing_group_id").empty().append('<option selected value="' + data.publishing_group.PARTY_ID + '">' + data.publishing_group.PARTY_NAME + '</option>');
        $("#publishing_group_id").select2('data', {
            id: data.publishing_group.PARTY_ID,
            label: data.publishing_group.PARTY_NAME
        });
    }
    if(data.hasOwnProperty('address')){
        if(data.address.length > 0) {
            var value = data.address[0];
            $('#address_type_0').val(value.ADDRESS_TYPE).trigger('change');
            $('#osdel_country_0').val(value.COUNTRY).trigger('change');
            $('#address_name_0').val(value.STREET);
            $('#postal_code_0').val(value.ZIP_CODE);
            $('#city_0').val(value.CITY);
            $('#department_0').val(value.STATE_PROVINCE);
            $('#phone_0').val(value.PHONE);
            $('#mail_0').val(value.EMAIL);
            $('#web_page_0').val(value.WEBSITE);
            data.address.shift();
            $.each(data['address'], function (key, value) {
                addAddressRow();
                $('#address_type_'+(window.address_id -1)).val(value.ADDRESS_TYPE).trigger('change');
                $('#osdel_country_'+(window.address_id -1)).val(value.COUNTRY).trigger('change');
                $('#address_name_'+(window.address_id -1)).val(value.STREET);
                $('#postal_code_'+(window.address_id -1)).val(value.ZIP_CODE);
                $('#city_'+(window.address_id -1)).val(value.CITY);
                $('#department_'+(window.address_id -1)).val(value.STATE_PROVINCE);
                $('#phone_'+(window.address_id -1)).val(value.PHONE);
                $('#mail_'+(window.address_id -1)).val(value.EMAIL);
                $('#web_page_'+(window.address_id -1)).val(value.WEBSITE);
            });
        }
    }
    $('#pub_cv').summernote('code', data.BIO_NOTE);
    if(!(data.WEB_VIEW == 0)){
        $('#web_show_status_yes').iCheck('check');
    }else{
        $('#web_show_status_no').iCheck('check');
    }
	if (data.bs_info) {
        $('#bookstore_' + (data.bs_info.BOOKSTORE ? 'yes' : 'no')).iCheck('check');
        $('#eshop_' + (data.bs_info.ESHOP ? 'yes' : 'no')).iCheck('check');
        $('#retail_' + (data.bs_info.RETAIL ? 'yes' : 'no')).iCheck('check');
        $('#wholesale_' + (data.bs_info.WHOLESALE ? 'yes' : 'no')).iCheck('check');
    }


    if (data.bs_book_category && Array.isArray(data.bs_book_category)) {
        $('#party_book_category').val(data.bs_book_category.BOOK_CATEGORY).trigger('change');
    }

    if (data.bs_characteristics && Array.isArray(data.bs_characteristics)) {
        $('#party_characteristics').val(data.bs_characteristics.CHARACTERISTICS).trigger('change');
    }
	if (data.bs_extra_characteristics && Array.isArray(data.bs_extra_characteristics)) {
        $('#party_extra_characteristics').val(data.bs_extra_characteristics.EXTRA_CHARACTERISTICS).trigger('change');
    }
	if (data.bs_special_book && Array.isArray(data.bs_special_book)) {
        $('#party_special_book').val(data.bs_special_book.SPECIAL_BOOK).trigger('change');
    }

    if(data.hasOwnProperty('suppliers')){
        if(data.suppliers.length > 0){
            var value = data.suppliers[0];
            $('#party_supplier_type_1').val(value.SUPPLIER_TYPE).trigger('change');
            $('#party_supplier_order_1').val(value.ORDER).trigger('change');
            if(value.hasOwnProperty('supplier_detail') && value.supplier_detail !== null) {
                $("#party_supplier_id_1").empty().append('<option selected value="' + value.supplier_detail.PARTY_ID + '">' + value.supplier_detail.PARTY_NAME + '</option>');
                $("#party_supplier_id_1").select2('data', {
                    id: value.supplier_detail.PARTY_ID,
                    label: value.supplier_detail.PARTY_NAME
                });
            }
            data.suppliers.shift();
        }
        $.each(data.suppliers, function (key, value){
            addSupplierRowPub();
            $('#party_supplier_type_'+(window.supplier_id -1)).val(value.SUPPLIER_TYPE).trigger('change');
            $('#party_supplier_order_'+(window.supplier_id -1)).val(value.ORDER).trigger('change');
            if(value.hasOwnProperty('supplier_detail') && value.supplier_detail !== null) {
                $('#party_supplier_id_'+(window.supplier_id -1)).empty().append('<option selected value="' + value.supplier_detail.PARTY_ID + '">' + value.supplier_detail.PARTY_NAME + '</option>');
                $('#party_supplier_id_'+(window.supplier_id -1)).select2('data', {
                    id: value.supplier_detail.PARTY_ID,
                    label: value.supplier_detail.PARTY_NAME
                });
            }
        });
    }
    if($('#party_type').val() === 'PUBLISHER'){
		if(data.hasOwnProperty('imprints')){
			if(data.imprints.length > 0){
				var value = data.imprints[0];
				$('.move-imprint-1').data('imprint-id',value.IMPRINT_ID);
				$('.remove-imprint-1').data('imprint-id',value.IMPRINT_ID);
				$('#imprint_id_1').val(value.IMPRINT_ID);
				if(value.hasOwnProperty('imprint') && value.imprints !== null) {
					$('#imprint_name_1').val(value.imprint.NAME).trigger('change');
					if(value.imprint.hasOwnProperty('isbn_prefixes')){
						if(value.imprint.isbn_prefixes.length > 0) {
							$('#isbn_prefix_1').val(value.imprint.isbn_prefixes[0].isbn_prefix.ISBN_PREFIX);
							 $('#author_publisher_1').val(value.imprint.isbn_prefixes[0].isbn_prefix.AUTHOR_PUBLISHER);
							value.imprint.isbn_prefixes.shift();
							$.each(value.imprint.isbn_prefixes, function(key1, value1){
								addRowIsbnPrefixFirst();
								if(value1.hasOwnProperty('isbn_prefix') && value1.isbn_prefix !== null){
									//console.log(value1.isbn_prefix.AUTHOR_PUBLISHER);
									$('#isbn_prefix_1_'+(window.isbn_prefix-1)).val(value1.isbn_prefix.ISBN_PREFIX);
									$('#isbn_prefix_id_1_'+(window.isbn_prefix-1)).val(value1.ISBN_PREFIX_ID);
									$('#author_publisher_1_'+(window.isbn_prefix-1)).val(value1.isbn_prefix.AUTHOR_PUBLISHER);
								}
							})
						}
					}
				}
				data.imprints.shift();
			}

			$.each(data.imprints, function (key, value){
				if(addRowImprintPub(true, value.IMPRINT_ID )) {
					if (value.hasOwnProperty('imprint') && value.imprints !== null) {
						$('#imprint_name_' + (window.imprint_name - 1)).val(value.imprint.NAME).trigger('change');
						if (value.imprint.hasOwnProperty('isbn_prefixes')) {
							if (value.imprint.isbn_prefixes.length > 0) {
								$('#isbn_prefix_' + (window.imprint_name - 1)+'_0').val(value.imprint.isbn_prefixes[0].isbn_prefix.ISBN_PREFIX);
								$('#isbn_prefix_id_'+ (window.imprint_name - 1)+'_0').val(value.imprint.isbn_prefixes[0].isbn_prefix.ISBN_PREFIX_ID);
								$('#author_publisher_' + (window.imprint_name - 1)+'_0').val(value.imprint.isbn_prefixes[0].isbn_prefix.AUTHOR_PUBLISHER);

								value.imprint.isbn_prefixes.shift();
								$.each(value.imprint.isbn_prefixes, function (key1, value1) {
									addRowIsbnPrefix($('#addRow-isbn-prefix-' + (window.imprint_name - 1)));
									if(value1.hasOwnProperty('isbn_prefix') && value1.isbn_prefix !== null){
										$('#isbn_prefix_'+ $('#addRow-isbn-prefix-' + (window.imprint_name - 1)).attr('name')+'_'+(window.isbn_prefix-1)).val(value1.isbn_prefix.ISBN_PREFIX);
										$('#isbn_prefix_id_'+ $('#addRow-isbn-prefix-' + (window.imprint_name - 1)).attr('name')+'_'+(window.isbn_prefix-1)).val(value1.ISBN_PREFIX_ID);
										$('#author_publisher_'+ $('#addRow-isbn-prefix-' + (window.imprint_name - 1)).attr('name')+'_'+(window.isbn_prefix-1)).val(value1.isbn_prefix.AUTHOR_PUBLISHER);
									}
								})
							}
						}
					}
				}
			});
		}
	}
}

$("#addRow-address").click(function () {
    addAddressRow();
})

function addAddressRow(){
    var html = '';
    html += '<div class="address-group">';
    html += '<hr class="solid"/>';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-2 text-left">';
    html += '<h6>';
    html += 'Eίδος διεύθυνσης <span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-9">';
    html += '<div class="pub-party-address-type-'+window.address_id+'">';
    html += '<select id="address_type_'+window.address_id+'" name="address_type['+window.address_id+']" data-parsley-required="true" data-parsley-class-handler=".pub-party-address-type-'+window.address_id+'" data-parsley-errors-container="#select-error-p4-'+window.address_id+'" class="form-control">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error-p4-'+window.address_id+'"></div>';
    html += '</div>';
    html += '</div>';   
    html += '<div class="col-sm-1">';
    html += '<button type="button" id="remove_address" class="btn td-n c-red-500 cH-red-200 fsz-md p-5" title="Διαγραφή"><i class="ti-trash"></i></button>';
    html += '</div>';
    html += '</div>';
	html += '<div class="row form-group">';
	html += '<label class="col-sm-1 text-left">';
    html += '<h6>';
    html += 'Διεύθυνση';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-5">';
    html += '<input id="address_name_'+window.address_id+'" class="form-control"  name="address['+window.address_id+']" type="text" data-parsley-maxlength="255" data-parsley-required="false" />';
    html += '</div>';
	html += '<label class="col-sm-1 text-left">';
    html += '<h6>';
    html += 'ΤΚ';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-2">';
    html += '<input id="postal_code_'+window.address_id+'" class="form-control"  name="postal_code['+window.address_id+']" type="text" data-parsley-maxlength="255" data-parsley-required="false" />';
    html += '</div>';
    html += '<label class="col-sm-1 text-left">';
    html += '<h6>';
    html += 'Πόλη';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-2">';
    html += '<input id="city_'+window.address_id+'" class="form-control"  name="city['+window.address_id+']" type="text" data-parsley-maxlength="255" data-parsley-required="false" />';
    html += '</div>';
	html += '</div>';
    html += '<div class="row form-group">';
    // html += '</div>';
    // html += '<div class="row form-group">';
    html += '<label class="col-sm-1 text-left">';
    html += '<h6>';
    html += 'Νομός';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-5">';
    html += ' <input id="department_'+window.address_id+'" class="form-control"  name="department['+window.address_id+']" type="text" data-parsley-maxlength="255" data-parsley-required="false" />';
    html += '</div>';
    html += '<label class="col-sm-1 text-left">';
    html += '<h6>';
    html += 'Χώρα  <span class="required">*</span>';
    html += '</h6>';
    html += ' </label>';
    html += ' <div class="col-sm-5">';
    html += '<div class="pub-party-country-'+window.address_id+'">';
    html += '<select  id="osdel_country_'+window.address_id+'" name="osdel_country['+window.address_id+']" data-parsley-required="true" data-parsley-class-handler=".pub-party-country-'+window.address_id+'" data-parsley-errors-container="#select-error-p5-'+window.address_id+'" class="form-control">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error-p5-'+window.address_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="row form-group">';
    html += '<label class="col-sm-1 text-left">';
    html += '<h6>';
    html += 'Τηλέφωνο';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-2">';
    html += '<input id="phone_'+window.address_id+'" class="form-control"  name="phone['+window.address_id+']" type="text" data-parsley-maxlength="255" data-parsley-required="false" />';
    html += '</div>';
    html += '<label class="col-sm-1 text-left">';
    html += '<h6>';
    html += 'e-mail';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-3">';
    html += '<input id="mail_'+window.address_id+'" class="form-control"  name="mail['+window.address_id+']" type="text" data-parsley-maxlength="255" data-parsley-required="false" />';
    html += '</div>';
    // html += '</div>';
    // html += '<div class="row form-group">';
    html += '<label class="col-sm-1 text-right">';
    html += '<h6>';
    html += 'Ιστοσελίδα';
    html += '</h6>';
    html += '</label>';
    html += '<div class="col-sm-4">';
    html += '<input id="web_page_'+window.address_id+'" class="form-control"  name="web_page['+window.address_id+']" type="text" data-parsley-maxlength="255" data-parsley-required="false" />';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    $('#newRow-address').append(html);

    $('#osdel_country_'+window.address_id).select2({
        placeholder: "Επιλέξτε χώρα",
        data: window.osdelCountries,
        width:"resolve",
        allowClear: true,
    });
    $('#address_type_'+window.address_id).select2({
        placeholder: "Επιλέξτε Είδος",
        data: window.addressTypes,
        width:"resolve",
        minimumResultsForSearch: -1,
    });
    window.address_id++;
}
$(document).on('click', '#remove_address', function () {
    $(this).closest('.address-group').remove();
});

$("#addRow-supplier-1").click(function () {
    // $('.supplier-group-first :input').attr('data-parsley-required', false);
    addSupplierRowPub();
});

function addSupplierRowPub(){
    $('.supplier-group-first select').attr('data-parsley-required', true);

    var html = '';
    html += '<div class="row form-group supplier-group">';
    //html += '<div class="col-sm-3"></div>';
    html += '<div class="col-sm-5">';
    html += '<div class="supplier-cont-'+window.supplier_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-required="true" data-parsley-errors-container="#select-error-p6-'+window.supplier_id+'" data-parsley-class-handler=".supplier-cont-'+window.supplier_id+'" id="party_supplier_id_'+window.supplier_id+'" name="party_supplier_id[]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error-p6-'+window.supplier_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-4">';
    html += '<div class="party-supplier-type-'+window.supplier_id+'">';
    html += '<select  style="width:100%" class="form-control" data-parsley-required="true" data-parsley-errors-container="#select-error-p7-'+window.supplier_id+'" data-parsley-class-handler=".party-supplier-type-'+window.supplier_id+'" id="party_supplier_type_'+window.supplier_id+'" name="party_supplier_type[]">';
    html += '<option></option>';
    html += '</select>';
    html += '<div id="select-error-p7-'+window.supplier_id+'"></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-2">';
    html += '<div class="supplier-cont-'+window.supplier_id+'">';
    html += '<input type="number" min="0" class="form-control" id="party_supplier_order_'+window.supplier_id+'" name="party_supplier_order[]"';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        html += ' readonly';
    }
    html += '/> ';
    html += '</div>';
    html += '</div>';
    html += '<div class="col-sm-1">';
    html += '<button type="button" id="remove_supplier_p" class="btn td-n  cH-red-200 fsz-md p-5 ';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        html += ' link-disabled';
    }
    html += '" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
    html += '</div>';
    html += '</div>';

    $('#newRow-supplier').append(html);

    initSelect2("#party_supplier_id_"+window.supplier_id, "Επιλέξτε Επωνυμία", window.selectPartySupplierIdData);

    $('#party_supplier_type_'+window.supplier_id).select2({
        placeholder: "Επιλέξτε Είδος",
        data: window.tradingRoles,
        width:"resolve",
        minimumResultsForSearch: -1,
        allowClear: true,

    });
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        $('#party_supplier_id_'+window.supplier_id).select2('enable', false);
        $('#party_supplier_type_'+window.supplier_id).select2('enable', false);
    }
    window.supplier_id++;

}

$(document).on('click', '#remove_supplier_p', function () {
    $(this).closest('.supplier-group').remove();
    if($('#newRow-supplier .supplier-group').length === 0){
        $('.supplier-group-first :input').removeAttr('data-parsley-required');
        $.each($('.supplier-group-first :input'), function(){
            $(this).parsley().reset();
        });
    }
});

$("#addRow-imprint").click(function () {
    addRowImprintPub(false);
});

function addRowImprintPub(isExisting, id = -1){
    $('.imprint-group-first :input').attr('data-parsley-required', true);

    var html = '';
    html += '<div class="imprint-group ';
    if(isExisting)
        html += ' isExisting ';
    html += '">';
    html += '<div class="row form-group">';
	if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
	html += '<label class="col-sm-7">';
    html += '<h6>Επωνυμία<span class="required">*</span></h6>';
    html += '</label>';
    //html += '<div class="col-sm-3"></div>';
	}
	if($.inArray('PUB_ADMIN',ddVariables.permissions) != -1) {
		html += '<label class="col-sm-4">';
		html += '<h6>Επωνυμία<span class="required">*</span></h6>';
		html += '</label>';
	
		html += '<label class="col-sm-3">';
		html += '<h6>';
		html += 'Αυτοέκδοση';
		html += '<span class="required">*</span>';
		html += '</h6>';
		html += '</label>'; 
	}
    html += '<label class="col-sm-3">';
    html += '<h6>';
    html += 'ISBN Prefix';
    html += '<span class="required">*</span>';
    html += '</h6>';
    html += '</label>';
    html += '</div>';
    html += '<div class="row form-group imprint-group-first">';
	if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {		
		if(isExisting)
        html += '<input type="hidden" id="imprint_id_'+window.imprint_name+'" name="imprint_ids['+window.imprint_name+']" value="'+id+'"/>';
		html += '<div class="col-sm-7">';
		html += '<input id="imprint_name_'+window.imprint_name+'" class="form-control" data-parsley-required="true" name="imprint_names['+window.imprint_name+']" maxlength="255"';
	}
	if($.inArray('PUB_ADMIN',ddVariables.permissions) != -1) {
		// html += '<div class="col-sm-3">';
		// html += '</div>';
		if(isExisting)
        html += '<input type="hidden" id="imprint_id_'+window.imprint_name+'" name="imprint_ids['+window.imprint_name+']" value="'+id+'"/>';
		html += '<div class="col-sm-4">';
		html += '<input id="imprint_name_'+window.imprint_name+'" class="form-control" data-parsley-required="true" name="imprint_names['+window.imprint_name+']" maxlength="255"';
	}
    // if(isExisting)
        // html += '<input type="hidden" id="imprint_id_'+window.imprint_name+'" name="imprint_ids['+window.imprint_name+']" value="'+id+'"/>';
    // html += '<div class="col-sm-4">';
    // html += '<input id="imprint_name_'+window.imprint_name+'" class="form-control" data-parsley-required="true" name="imprint_names['+window.imprint_name+']" maxlength="255"';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        html += ' readonly';
    }
    html += '/>';
    html += '</div>';
	if($.inArray('PUB_ADMIN',ddVariables.permissions) != -1) {
		html += '<div class="col-sm-3">';
		html += '<input id="author_publisher_'+window.imprint_name+'_0" class="form-control" data-parsley-required="false" name="author_publishers['+window.imprint_name+'][]" ';    
		html += '/>';
		html += '</div>';
	}
    html += '<div class="col-sm-4">';
    html += '<input id="isbn_prefix_'+window.imprint_name+'_0" class="form-control" data-parsley-required="true" name="isbn_prefixes['+window.imprint_name+'][]" data-parsley-valid-isbn=""';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        html += ' readonly';
    }
    html += '/>';
    html += '</div>';
    html += '<div class="col-sm-1">';
    html += '</div>';
    html += '</div>';

    html += '<div class="test-group">';
    html += '<div id="newRow-isbn-prefix">';
    html += '</div>';
    // html += '</div>';
    html += '<div class="row form-group">';
    html += '<div class="col-sm-11">';
    html += '<button id="addRow-isbn-prefix-'+window.imprint_name+'" type="button" name="'+window.imprint_name+'" class="btn btn-outline-purple-custom fl-r addRow-isbn-prefix';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        html += ' link-disabled';
    }
    html +='">Προσθήκη ISBN Prefix</button>';
    html += '<button id="remove_imprint" type="button" class="btn td-n  cH-red-200 fl-r pr-2';
    if(isExisting) {
        html += ' isExisting ';
        if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
            html += ' link-disabled';
        }
    }
    html += '"';
    if(isExisting)
        html += ' data-imprint-id="'+id+'" ';
    html += ' style="color:#f44336">Διαγραφή Imprint</button>';
    if(isExisting) {
        html += '<button id="move_imprint" type="button" class="btn td-n btn-outline-info-custom fl-r pr-2';
        if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
            html += ' link-disabled';
        }
        html += '" data-imprint-id="' + id + '" data-toggle="modal" data-target="#moveImprintModal">Μεταφορά Imprint</button>';
    }
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '<hr class="solid"/>';
    html += '</div>';

    $('#newRow-imprint').append(html);

    $('#isbn_prefix_'+window.imprint_name+'_0').on('change',function(e) {

        var coIsbnToCheck = $(this).val();
        $(this).parsley().removeError('isbnFormatError');
        if(coIsbnToCheck !== '') {
            if (!checkIsbnPrefix(coIsbnToCheck)) {
                $(this).parsley().addError('isbnFormatError', {message: 'Μή έγκυρη μορφή ISBN Prefix'});
            }
        }
    });

    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        $('#party_supplier_id_'+window.supplier_id).select2('enable', false);
        $('#party_supplier_type_'+window.supplier_id).select2('enable', false);
        $('#party_supplier_order_'+window.supplier_id).attr('readonly','readonly');
    }
    window.imprint_name++;

    return true;
}

$(document).on('click', '#remove_isbn_prefix', function () {
    $(this).closest('.isbn-prefix-group').remove();
});


$(document).on('click', '.addRow-isbn-prefix', function (e) {
    addRowIsbnPrefix($(this));
});

function addRowIsbnPrefix(obj){
    var buttonIndex = obj.attr('name');
    var html = '';
    html += '<div class="row form-group isbn-prefix-group">';
    html += '<div class="col-sm-4">';
    html += '</div>';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) != -1) {
		html += '<div class="col-sm-3">';
		html += '<input id="author_publisher_'+buttonIndex+'_'+window.isbn_prefix+'" class="form-control" data-parsley-required="false" name="author_publishers['+buttonIndex+'][]" ';    
		html += '/>';
		html += '</div>';
	}else {
		html += '<div class="col-sm-3">';
		html += '</div>';
	}
    html += '<div class="col-sm-4">';
    html += '<input id="isbn_prefix_'+buttonIndex+'_'+window.isbn_prefix+'" class="form-control" data-parsley-required="true" name="isbn_prefixes['+buttonIndex+'][]" maxlength="255"';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        html += ' readonly';
    }
    html += '/>';
    html += '</div>';
    html += '<div class="col-sm-1">';
    html += '<button type="button" id="remove_isbn_prefix" class="btn td-n  cH-red-200 fsz-md p-5';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        html += ' link-disabled';
    }
    html += '" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
    html += '</div>';
    html += '</div>';

    obj.closest('.test-group').find('#newRow-isbn-prefix').append(html);
    $('#isbn_prefix_'+buttonIndex+'_'+window.isbn_prefix).on('change',function(e) {
        var coIsbnToCheck = $(this).val();
        $(this).parsley().removeError('isbnFormatError');
        if(coIsbnToCheck !== '') {
            if (!checkIsbnPrefix(coIsbnToCheck)) {
                $(this).parsley().addError('isbnFormatError', {message: 'Μή έγκυρη μορφή ISBN prefix'});
            }
        }
    });
    window.isbn_prefix++;
}

$("#addRow-isbn-prefix").click(function () {
    addRowIsbnPrefixFirst();
});

function addRowIsbnPrefixFirst(){
    var html = '';
    html += '<div class="row form-group isbn-prefix-group">';
    html += '<div class="col-sm-4">';
    html += '</div>';
     if($.inArray('PUB_ADMIN',ddVariables.permissions) != -1) {
		html += '<div class="col-sm-3">';
		html += '<input id="author_publisher_1_'+window.isbn_prefix+'" class="form-control" data-parsley-required="false" name="author_publishers[1][]" maxlength="255"';  
		html += '/>';
		html += '</div>';
	}else {
		html += '<div class="col-sm-3">';
		html += '</div>';
	}
    html += '<div class="col-sm-4">';
    html += '<input id="isbn_prefix_1_'+window.isbn_prefix+'" class="form-control" data-parsley-required="true" name="isbn_prefixes[1][]" maxlength="255"';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        html += ' readonly';
    }
    html += '/>';
    html += '</div>';
    html += '<div class="col-sm-1">';
    html += '<button type="button" id="remove_isbn_prefix" class="btn td-n  cH-red-200 fsz-md p-5';
    if($.inArray('PUB_ADMIN',ddVariables.permissions) === -1) {
        html += ' link-disabled';
    }
    html += '" title="Διαγραφή" style="color:#f44336"><i class="ti-trash"></i></button>';
    html += '</div>';
    html += '</div>';
    $('#newRow-isbn-prefix').append(html);

    $('#isbn_prefix_1_'+window.isbn_prefix).on('change',function(e) {
        var coIsbnToCheck = $(this).val();
        $(this).parsley().removeError('isbnFormatError');
        if(coIsbnToCheck !== '') {
            if (!checkIsbnPrefix(coIsbnToCheck)) {
                $(this).parsley().addError('isbnFormatError', {message: 'Μή έγκυρη μορφή ISBN prefix'});
            }
        }
    });

    window.isbn_prefix++;
}


function checkIsbnPrefix(isbn){
    isbn = $.trim(isbn);
    isbn = isbn.replace(/-/g,'');
    if(!$.isNumeric(isbn))
        return false;
    return true;
}
